// Presentational only — no Firestore I/O, no user object. Driven entirely by props.
//
// mode='first-time' — for users with no prior acceptance record on file (pre-ToS users).
//   Shows the full first-time consent text matching the /register checkbox copy.
// mode='update' — for users on an older version. Shows "we've updated our terms" + the
//   WHAT_CHANGED bullets + I-agree + delete-account remedy.
//
// Hard block: there is no close affordance. The only paths off the modal are
// "I agree" or the mailto:support@maiatech.ai delete-account link, matching ToS §9.

import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL_VERSION, WHAT_CHANGED_FROM_PREVIOUS } from './version';
import './LegalAcceptance.css';

const DELETE_ACCOUNT_MAILTO =
  'mailto:support@maiatech.ai?subject=Account%20deletion%20request';

const LegalAcceptanceModal = ({ mode, onAccept, accepting }) => {
  const isFirstTime = mode === 'first-time';

  return (
    <div className="legal-acceptance-backdrop" role="dialog" aria-modal="true">
      <div className="legal-acceptance-modal">
        <h2>
          {isFirstTime
            ? 'Please review our Terms of Use and Privacy Policy'
            : 'We\'ve updated our Terms of Use and Privacy Policy'}
        </h2>

        {isFirstTime ? (
          <p>
            To continue using Maia, please confirm you have read and agree to the{' '}
            <Link to="/legal/terms" target="_blank" rel="noopener noreferrer">
              Terms of Use
            </Link>{' '}
            and{' '}
            <Link to="/legal/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </Link>
            . These describe how Maia handles your calls, your data, and what you
            agree to when using the service.
          </p>
        ) : (
          <>
            <p>
              We've updated the{' '}
              <Link to="/legal/terms" target="_blank" rel="noopener noreferrer">
                Terms of Use
              </Link>{' '}
              and{' '}
              <Link to="/legal/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </Link>
              . Please review and accept the new version (
              <strong>{LEGAL_VERSION}</strong>) to continue using Maia.
            </p>
            {WHAT_CHANGED_FROM_PREVIOUS.length > 0 && (
              <>
                <p><strong>What changed:</strong></p>
                <ul>
                  {WHAT_CHANGED_FROM_PREVIOUS.map((bullet, i) => (
                    <li key={i}>{bullet}</li>
                  ))}
                </ul>
              </>
            )}
          </>
        )}

        <div className="legal-acceptance-actions">
          <button
            type="button"
            className="legal-acceptance-accept"
            onClick={onAccept}
            disabled={accepting}
          >
            {accepting ? 'Saving…' : 'I agree'}
          </button>
          <a
            href={DELETE_ACCOUNT_MAILTO}
            className="legal-acceptance-decline"
          >
            I do not agree — delete my account
          </a>
        </div>
      </div>
    </div>
  );
};

export default LegalAcceptanceModal;
